<template>
  <form @submit.prevent="onUpload">
    <input
      v-if="!archivo.Id || archivo.EstadoGestion == 0"
      type="file"
      @change="handleFileChange"
      ref="fileInput"
      style="display: none"
      :disabled="!cargaHabilitada"
    />

    <div
      v-if="!archivo.Id || archivo.EstadoGestion == 0"
      class="dropzone"
      :class="{
        'is-file': isFile,
        'disabled-zone': !cargaHabilitada,
      }"
      :style="fileBackground"
      @click="triggerFileInput"
      @drop.prevent="handleDrop"
      @dragover.prevent
      @dragenter.prevent
    >
      <div v-if="!cargaHabilitada" class="overlay-message">
        <i class="ti ti-lock" style="font-size: 2rem"></i>
        <p class="mt-2 text-center">Carga no disponible</p>
      </div>
      <template v-else>
        <div v-if="loader" class="loader"></div>
        <div class="overlay" v-if="imageUrl"></div>
        <div v-if="!file" class="d-flex flex-column align-items-center">
          <i :class="['ti ti-cloud-up text-muted']" style="font-size: 2rem"></i>
          <br />
          <span class="text-center">
            <strong>Arrastra tu documento aquí</strong><br />
            o haz clic para seleccionar
          </span>
          <!-- Mostrar los tipos de formatos permitidos -->
          <small class="text-muted mt-2 text-center">
            Formatos permitidos: {{ extensionOfFileTypes.join(", ") }}
          </small>
        </div>
        <div
          v-else
          class="d-flex flex-column align-items-center"
          style="z-index: 3"
        >
          <i
            :class="`ti ti-file-check text-muted ${loader && 'fa-bounce'}`"
            style="font-size: 2rem"
          ></i>
          <br />
          <span class="text-center">
            <strong>Documento listo:</strong><br />
            <span class="text-primary font-weight-bold">{{ name }}</span>
          </span>
        </div>
      </template>
    </div>
    <div v-else class="d-flex flex-column align-items-center mt-auto mb-auto">
      <i
        :class="`ti ti-file-check ${loader && 'fa-bounce'}`"
        style="font-size: 2rem"
      ></i>
      <br />
      <span class="text-center">
        <strong>Documento cargado:</strong><br />
        <span class="text-primary font-weight-bold">{{
          archivo.NombreArchivo
        }}</span>
      </span>
    </div>
    <transition name="fade-slide" appear>
      <div
        v-if="progresoSimulado > 0"
        class="progress-container d-flex align-items-center"
        style="width: 100%; padding: 0 1rem; margin-top: 1rem; gap: 1rem"
      >
        <progress
          :value="progresoSimulado"
          max="100"
          class="progress-minimal"
        ></progress>
        <span class="progress-percentage">{{ progresoSimulado }}%</span>
      </div>
    </transition>
  </form>
</template>

<script>
import { eventBus } from "../../main";

import Swal from "sweetalert2";
import _ from "lodash";

export default {
  props: {
    fileTypes: {
      type: Array,
      default: () => [],
    },
    urlDir: {
      type: String,
      default: () => "",
      required: true,
    },
    injectData: {
      type: Object,
      default: () => {},
    },
    id: {
      type: Number,
      default: () => 0,
    },
    archivo: {
      type: Object,
      default: () => {},
    },
    cargaHabilitada: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      file: null,
      name: null,
      imageUrl: null,
      typeFile: null,
      loader: false,
      archivosCargados: [],
      progreso: 0,
      progresoSimulado: 0,
      simulacionActiva: false,
      tiempoInicioCarga: null,
      progresoRealRapido: false,
    };
  },
  beforeDestroy() {
    console.log("beforeDestroy");

    if (this.$route.name !== "AgregarArchivoCuentaCobro") {
      console.log("ok");

      eventBus.$off("GuardandoArchivosCDC");
    }
  },
  async mounted() {
    eventBus.$on("GuardandoArchivosCDC", async (data) => {
      console.log("GuardandoArchivosCDC-->", data);

      if (data.length > 0) {
        this.archivosCargados = data;

        await this.onUpload();
      }
    });
  },
  watch: {
    "archivo.Id": {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.restaurar();
        }
      },
      immediate: true,
    },
  },
  computed: {
    backgroundStyle() {
      if (this.imageUrl) {
        return {
          backgroundImage: `url("${this.imageUrl}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
        };
      }
      return {};
    },
    isFile() {
      return this.file ? true : false;
    },
    fileBackground() {
      if (this.file) {
        let backgroundImage = this.imageUrl ? `url("${this.imageUrl}")` : "";
        return {
          backgroundImage: backgroundImage,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        };
      }
      return {};
    },
    extensionOfFileTypes() {
      return this.fileTypes.map((elment) => {
        return elment.substring(elment.lastIndexOf("/") + 1);
      });
    },
  },
  methods: {
    quitarTildesYEspacios(input) {
      let sinTildes = _.deburr(input);
      let sinEspacios = sinTildes.replace(/\s+/g, "");
      return sinEspacios;
    },
    restaurar() {
      this.file = null;
      this.imageUrl = null;
    },
    triggerFileInput() {
      if (!this.cargaHabilitada) {
        this.showErrorMessage();
        return;
      }
      if (this.loader) {
        return;
      }
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        this.validateAndProcessFile(selectedFile);
      }
    },
    handleDrop(event) {
      if (!this.cargaHabilitada) {
        this.showErrorMessage();
        return;
      }
      if (this.loader) {
        return;
      }
      const selectedFile = event.dataTransfer.files[0];
      if (selectedFile) {
        this.validateAndProcessFile(selectedFile);
      }
    },
    showErrorMessage() {
      Swal.fire({
        icon: "warning",
        title: "Período cerrado",
        text: "La carga de documentos no está habilitada en este período.",
        confirmButtonText: "Entendido",
      });
    },
    validateAndProcessFile(selectedFile) {
      console.log(selectedFile.type);

      console.log(this.id);

      if (
        this.fileTypes.includes(selectedFile.type) &&
        selectedFile.name.split(".").length <= 2
      ) {
        eventBus.$emit("archivoCargado", this.id);
        this.file = selectedFile;
        this.typeFile = this.file.name.substring(
          this.file.name.lastIndexOf(".")
        );
        this.name = this.file.name;
        if (selectedFile.type.startsWith("image/")) {
          this.imageUrl = URL.createObjectURL(selectedFile);
          console.log("Archivo de imagen seleccionado:", selectedFile);
        }
      } else {
        console.error("Archivo rechazado - formato no válido.");

        if (!this.fileTypes.includes(selectedFile.type)) {
          Swal.fire({
            icon: "info",
            title: "Formato no válido",
            html: `Solo se permiten archivos: <strong>${this.extensionOfFileTypes.join(
              ", "
            )}</strong>`,
            confirmButtonText: "Entendido",
          });
        }

        if (selectedFile.name.split(".").length > 2) {
          Swal.fire({
            icon: "error",
            title: "Nombre de archivo inválido",
            text: "El nombre del archivo no puede contener puntos adicionales.",
            confirmButtonText: "Entendido",
          });
        }

        this.file = null;
        this.imageUrl = null;

        eventBus.$emit("archivoNoValido", this.id);
      }
      this.$refs.fileInput.value = "";
    },
    async onUpload() {
      try {
        console.log("Procesando archivo ID:", this.id);

        if (!this.archivosCargados.includes(this.id)) {
          console.log(
            "Documento ID",
            this.id,
            "no está en la lista de procesamiento"
          );
          return;
        }

        if (!this.file) {
          console.warn(`No hay documento para el ID ${this.id}, omitiendo...`);
          eventBus.$emit("archivosSubidos", {
            data: this.id,
            tipo: "error",
          });
          return;
        }

        // Nombre con fechas para la URL del servidor (evita sobrescrituras)
        const nameFileParaUrl = this.injectData.NombreArchivoParaUrl || this.injectData.NombreArchivo;
        // Nombre original para guardar en BD (sin fechas)
        const nameFileParaBD = this.injectData.NombreArchivo;
        this.loader = true;

        const newPath = this.quitarTildesYEspacios(this.urlDir);
        const cleanPath = newPath.replace(/\/+$/, "");
        const filename = `_${nameFileParaUrl}${this.typeFile}`;
        const filenameParaBD = `_${nameFileParaBD}${this.typeFile}`;
        const urlImg = cleanPath.split("/").join("|");

        this.tiempoInicioCarga = Date.now();
        this.iniciarProgresoSimulado();

        const formData = new FormData();
        formData.append("file", this.file);
        formData.append("remoteFilePath", urlImg);
        formData.append("FileName", filename);
        formData.append("fileType", this.file.type);

        let isSave = await this.$store.dispatch("hl_post_file_axios", {
          path: "CargaMultimedia/UploadFile",
          data: formData,
          onProgress: (percent) => {
            console.log(
              `Progreso de carga documento ID ${this.id}:`,
              percent + "%"
            );
            this.progreso = percent;

            if (percent >= 50 && !this.progresoRealRapido) {
              const tiempoTranscurrido = Date.now() - this.tiempoInicioCarga;
              if (tiempoTranscurrido < 2000) {
                this.progresoRealRapido = true;
                this.acelerarProgresoSimulado();
              }
            }

            if (percent < 50) {
              this.actualizarProgresoSimulado(percent);
            }
          },
        });

        console.log("isSave-->", isSave);

        await new Promise((resolve) => setTimeout(resolve, 500));

        this.completarProgresoSimulado();

        if (!isSave.respuesta) {
          throw new Error(isSave.mensaje || "Error al subir el archivo");
        }

        const url =
          "https://www.helexiumfiles.com/" + cleanPath + "/" + filename;

        const archivoData = {
          Id: this.archivo.Id || 0,
          PersonaId: this.injectData.PersonaId,
          NombreArchivo: filenameParaBD,  // Nombre original sin fechas para la BD
          UrlArchivo: url,  // URL con fechas para evitar sobrescrituras en el servidor
          FechaSubida: this.injectData.FechaSubida,
          PeriodoReferencia: this.injectData.PeriodoReferencia,
          FechaInicio: this.injectData.FechaInicio,
          FechaFin: this.injectData.FechaFin,
          EstadoGestion: this.archivo.Id ? -1 : null,
        };

        eventBus.$emit("archivoProcesadoParaBatch", {
          archivoId: this.id,
          archivoData: archivoData,
          esResubido: !!this.archivo.Id,
        });

        this.restaurar();

        eventBus.$emit("archivosSubidos", {
          data: this.id,
          tipo: this.archivo.Id ? "resubido" : "subido",
        });

        console.log(
          `Documento ID ${this.id} procesado exitosamente para carga en lote`
        );
      } catch (error) {
        console.error(`Error procesando documento ID ${this.id}:`, error);

        eventBus.$emit("archivosSubidos", {
          data: this.id,
          tipo: "error",
        });

        if (
          error.message.includes("Error al subir el archivo") ||
          error.message.includes("Error en el backend")
        ) {
          Swal.fire({
            icon: "error",
            title: "Error al cargar",
            text: "No se pudo cargar el documento. Verifica tu conexión e inténtalo de nuevo.",
            confirmButtonText: "Entendido",
          });
        }
      } finally {
        this.loader = false;
        this.progreso = 0;
        this.progresoSimulado = 0;
        this.simulacionActiva = false;
        this.tiempoInicioCarga = null;
        this.progresoRealRapido = false;
      }
    },
    iniciarProgresoSimulado() {
      this.progresoSimulado = 0;
      this.simulacionActiva = true;

      this.simulacionProgreso();
    },

    simulacionProgreso() {
      if (!this.simulacionActiva) return;

      let incremento, intervalo;

      if (this.progresoRealRapido) {
        if (this.progresoSimulado < 30) {
          incremento = 25;
          intervalo = 100;
        } else if (this.progresoSimulado < 70) {
          incremento = 30;
          intervalo = 80;
        } else {
          incremento = 20;
          intervalo = 120;
        }
      } else {
        if (this.progresoSimulado < 30) {
          incremento = 8;
          intervalo = 300;
        } else if (this.progresoSimulado < 70) {
          incremento = 12;
          intervalo = 250;
        } else {
          incremento = 6;
          intervalo = 400;
        }
      }

      this.progresoSimulado = Math.min(this.progresoSimulado + incremento, 100);

      if (this.progresoSimulado < 100 && this.simulacionActiva) {
        setTimeout(() => {
          this.simulacionProgreso();
        }, intervalo);
      }
    },

    actualizarProgresoSimulado(progresoReal) {
      if (progresoReal < 50 && progresoReal > this.progresoSimulado) {
        this.progresoSimulado = progresoReal;
      }
    },

    acelerarProgresoSimulado() {
      console.log("Carga rápida detectada, optimizando progreso visual");
    },

    completarProgresoSimulado() {
      this.simulacionActiva = false;
      this.progresoSimulado = 100;

      setTimeout(() => {
        if (this.progresoSimulado === 100) {
          this.progresoSimulado = 0;
        }
      }, 2000);
    },
  },
};
</script>

<style scoped>
.disabled-zone {
  opacity: 0.6;
  cursor: not-allowed;
}

.overlay-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 4;
}

form {
  width: 100%;
  min-height: 200px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dropzone {
  width: 100%;
  min-height: 150px;
  height: 80%;
  border: 2px dashed #ccc;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  transition: 0.3s all;

  &:hover {
    background-color: #ececec;
  }

  .dark &:hover {
    background-color: #131416;
  }
}

.is-file {
  background-color: #ececec;

  .dark & {
    background-color: #131416;
  }
}

.loader {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 2;
}

.actions {
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.progress-container {
  transition: all 0.3s ease-in-out;
}

.progress-minimal {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  border: none;
  background-color: #e9ecef;
  -webkit-appearance: none;
  appearance: none;
}

.dark .progress-minimal {
  background-color: #131416;
}

.progress-minimal::-webkit-progress-bar {
  background-color: #e9ecef;
  border-radius: 4px;
}

.dark .progress-minimal::-webkit-progress-bar {
  background-color: #131416;
}

.progress-minimal::-webkit-progress-value {
  background-color: #1a5cff;
  border-radius: 4px;
  transition: width 0.3s ease-in-out;
}

.progress-minimal::-moz-progress-bar {
  background-color: #1a5cff;
  border-radius: 4px;
  transition: width 0.3s ease-in-out;
}

.progress-percentage {
  font-size: 0.875rem;
  font-weight: 500;
  /* color: #1a5cff; */
  min-width: 3rem;
  text-align: right;
}

.fade-slide-enter-active {
  transition: all 0.4s ease-out;
}

.fade-slide-leave-active {
  transition: all 0.3s ease-in;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-15px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
